import { ISelectedFiles } from '@molecules/AttachFilesBlock/ISelectedFiles';

/**
 * Файлы, которые ещё не уходили на сервер. Действия с вложениями грузят файлы до самого
 * действия: если отказало действие, файлы уже приложены к документу — повторная отправка
 * не должна приложить их второй раз. Свойства идут параллельным массивом, фильтруются вместе.
 */
export const skipUploadedFiles = (selected: ISelectedFiles, uploaded: ReadonlySet<File>): ISelectedFiles => {
    const keep = selected.files.map((file) => !uploaded.has(file));
    return {
        files: selected.files.filter((_, index) => keep[index]),
        attachProperties: selected.attachProperties.filter((_, index) => keep[index] ?? true),
    };
};

/** Действие отказало после загрузки файлов: они уже в документе. */
export const UPLOADED_FILES_WARNING = 'Файлы уже приложены к документу: при повторной отправке они не задублируются.';

/** Выбраны ли в блоке вложений файлы — повод спросить перед закрытием окна. */
export const hasSelectedFiles = (block: { getData: () => ISelectedFiles } | null | undefined): boolean =>
    (block?.getData().files.length ?? 0) > 0;
